exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-SurveyStatusEntry__line-1 {\n  display: flex;\n  padding-bottom: .7em;\n  align-items: center;\n}\n.cs-SurveyStatusEntry__line-2 {\n  display: flex;\n  align-items: center;\n}\n.cs-SurveyStatusEntry__mark {\n  flex: 2;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.cs-SurveyStatusEntry__mark--complete {\n  flex: 2;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #080;\n}\n.cs-SurveyStatusEntry__mark--in-progress {\n  flex: 2;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #770;\n}\n.cs-SurveyStatusEntry__mark--not-started {\n  flex: 2;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #700;\n}\n.cs-SurveyStatusEntry__type {\n  flex: 3;\n}\n.cs-SurveyStatusEntry__period {\n  flex: 1;\n}\n.cs-SurveyStatusEntry__remark {\n  flex: 4;\n}\n.cs-SurveyStatusEntry__score {\n  flex: 2;\n  text-align: right;\n}\n.cs-SurveyStatusEntry__actions {\n  flex: 2;\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/SurveyStatusEntry/SurveyStatusEntry.less
// module id = 925
// module chunks = 0